/**
 * Created by daniel.gonzalez on 9/15/15.
 */

'use strict';

const React = require('react');
const PropTypes = require('prop-types');
const ContextComponent = require('../../../global/components/ContextComponent');
const Measurement = require('../../components/Measurement/Measurement-view');

class DetailsDimensions extends ContextComponent {
    constructor(props) {
        super(props);
    }

    render() {
        const detailItems = this.props.contents.map((content, i) => {
            return (
                <div key={i}>
                    <Measurement values={content} />
                </div>
            );
        });

        return (
            <li className="pdp-details-entry">
                <div className="pdp-details-entry-title-container">
                    <span className="pdp-details-entry-title">{this.props.title}</span>
                </div>
                <div className="pdp-details-entry-content-container" data-tn={this.props.testName}>
                    {detailItems}
                </div>
            </li>
        );
    }
}

DetailsDimensions.propTypes = {
    contents: PropTypes.arrayOf(PropTypes.array.isRequired).isRequired,
    testName: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
};

module.exports = DetailsDimensions;



// WEBPACK FOOTER //
// ./assets/js/newPdp/details/components/DetailsDimensions.jsx